/**
 * Representation of a user interaction .
 */
export class UserInteractionV22 {
    constructor(options) {
        this._enabled = false; // action might be inactive
        this.listener = new Map();
        if (options) {
            this.updateV2(options);
        }
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._enabled = value;
        this.listener.forEach((listener) => listener());
    }
    getHref(params, urlParams) {
        return this._getHref ? this._getHref(params, urlParams) : undefined;
    }
    get href() {
        return this.getHref(undefined, new URLSearchParams());
    }
    registered() {
        return Boolean(this._action);
    }
    onActivate(params, urlParams) {
        if (this._action && this.enabled) {
            this._action(params, urlParams);
        }
    }
    subscribe(id, listener) {
        this.listener.set(id, listener);
    }
    unsubscribe(id) {
        this.listener.delete(id);
    }
    update(options) {
        this._enabled = Boolean(options);
        this._getHref = () => (options === null || options === void 0 ? void 0 : options.href) || undefined;
        this._action = (options === null || options === void 0 ? void 0 : options.action.bind(options)) || undefined;
        this.listener.forEach((listener) => listener());
    }
    updateV2(options) {
        var _a;
        this._enabled = Boolean(options);
        this._getHref = ((_a = options === null || options === void 0 ? void 0 : options.getHref) === null || _a === void 0 ? void 0 : _a.bind(options)) || undefined;
        this._action = (options === null || options === void 0 ? void 0 : options.action.bind(options)) || undefined;
        this.listener.forEach((listener) => listener());
    }
}
//# sourceMappingURL=user-interaction-v2.js.map